import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BaseService } from '../base.service';
import { Empresa } from 'src/app/models/configuracion/empresa.model';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EmpresaService extends BaseService {

    recordName = 'empresas';

    url = `${ environment.host }/empresa`;

    codigoModulo = Empresa.CODIGO_MODULO;
    codigoRegistro = Empresa.CODIGO_REGISTRO;

    async getAdicionalFilters( isget?: boolean ): Promise<Record<string, any>[]> {
        return [];
    }

    async enviarCorreo( filtros: Record<string, any> ) {
        const url = `${this.url}/enviar-correo-prueba`
        try {
            await this.updateToken();
            const resp = await lastValueFrom(this.http.post<any>(url, { filtros }, { headers: this.header }));
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }

    async crearWhatsappReactivationTemplate(idEmpresa: number) {
        const url = `${this.url}/${idEmpresa}/whatsapp-reactivation-template`;
        try {
            await this.updateToken();
            return await lastValueFrom(this.http.post<any>(url, {}, { headers: this.header }));
        } catch (error: any) {
            return this.checkError(error);
        }
    }

}
